import React from 'react';
import classNames from 'classnames';
import objectPath from 'object-path';

import { ExclamationIcon } from '@heroicons/react/outline';

import nodeIcons from '../utils/nodeIcons';
import { Nullable } from 'src/types/nullable.type';
import { Destination } from 'src/common/interfaces/destination.interface';
import { DestinationLogo } from 'src/common/DestinationLogo';

interface ContentTypeLogoProps {
  contentType: string;
  destination?: Nullable<Destination>;
  externalLinkUrl?: Nullable<string>;
  className?: string;
  logoSize?: 'small' | 'large';
}

export const ContentTypeLogo = ({ contentType, destination, externalLinkUrl, className, logoSize = 'large' }: ContentTypeLogoProps) => {
  const NodeIcon = objectPath.get(nodeIcons, [contentType, 'regular'], null) as Nullable<React.ElementType>;

  const classes = classNames('flex-shrink-0', className);

  const getWrapperClasses = (hasBackground = true) => {
    return classNames(
      'flex flex-shrink-0 h-10 w-10 items-center justify-center min-w-0 relative rounded-md text-bedrock-brand-text',
      {
        'bg-bedrock-brand-primary': hasBackground,
        'bg-white': !hasBackground,
      }
    );
  };

  if (destination || externalLinkUrl) {
    return <DestinationLogo destination={destination} externalLinkUrl={externalLinkUrl} size={logoSize} />;
  } else {
    if (NodeIcon) {
      return (
        <div className={getWrapperClasses(true)}>
          <NodeIcon className={classes} />
        </div>
      );
    }
  }

  return null;
};
